
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import { createSelector } from "reselect";
import { addEventCompareConflicts } from '../../../helpers/sport/betslip';
import { PayCasinoLotteryWinTicket, TitoAcceptBet, TitoCashoutAcceptBet, addToBalance } from "../../../actions/terminal";
import Zergling from '../../../helpers/zergling';
import Helpers from '../../../helpers/helperFunctions';
import { OpenPopup } from "../../../actions/ui";

class TicketInDms extends Component {
    constructor (props) {
        super(props);
        this.state = {
            Name: '',
            Surname: '',
            CNP: ''
        };
        this.depositMoney = this.depositMoney.bind(this);
        this.copyToBetSlip = this.copyToBetSlip.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSurNameChange = this.handleSurNameChange.bind(this);
        this.handleCnpChange = this.handleCnpChange.bind(this);
        this.addCasinoWinAmount = this.addCasinoWinAmount.bind(this);
        this.addToBalance = this.addToBalance.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    handleNameChange (e) {
        this.setState({ Name: e });
        // this.setState({Name: this.state.Name.charAt(0).toUpperCase() + this.state.Name.slice(1)});
    }
    handleSurNameChange (e) {
        this.setState({ Surname: e });
        // this.setState({Surname: this.state.Surname.charAt(0).toUpperCase() + this.state.Surname.slice(1)});
    }
    handleCnpChange (e) {
        this.setState({ CNP: e });
    }

    isFormValid () {
        return Object.keys(this.state).every(item => !!this.state[item]);
    }

    isInputValid (name, surname) {
        const letters = /^(?!.*([QqWw])|.*([A-Za-z])\2{2})[A-Za-z]+$/i;
        return name.length >= 3 && surname.length >= 3 && name.match(letters) !== null && surname.match(letters) !== null;
    }
    depositMoney () {
        return () => {
            let data = this.props.data;
            let inputData = this.state;
            inputData.Name = Helpers.MakeLetterCapitalize(inputData.Name);
            inputData.Surname = Helpers.MakeLetterCapitalize(inputData.Surname);
            inputData = JSON.stringify(inputData);
            this.props.dispatch(TitoAcceptBet({barcode: data.barcode.toString(), amount: data.amount, tax_amount: data.tax_amount, inputData}));
            this.props.closePopup()();
        };
    }
    addCasinoWinAmount () {
        return () => {
            let data = this.props.data;
            let userData = this.state;
            userData.Name = Helpers.MakeLetterCapitalize(userData.Name);
            userData.Surname = Helpers.MakeLetterCapitalize(userData.Surname);
            userData = JSON.stringify(userData);
            this.props.dispatch(PayCasinoLotteryWinTicket({data, userData}));
            this.props.closePopup()();
        };
    }
    addToBalance () {
        let userData = this.state;
        let tickets = this.props.tickets;
        userData.Name = Helpers.MakeLetterCapitalize(userData.Name);
        userData.Surname = Helpers.MakeLetterCapitalize(userData.Surname);
        this.props.closePopup()();
        this.props.dispatch(OpenPopup('multipleTicketsPopup'));
        this.props.dispatch(addToBalance({user_data: userData, tickets}));
    }

    cancel() {
        this.props.closePopup()();
    }

    cashoutDepositMoney () {
        return () => {
            let data = this.props.data;
            let inputData = this.state;
            inputData.Name = Helpers.MakeLetterCapitalize(inputData.Name);
            inputData.Surname = Helpers.MakeLetterCapitalize(inputData.Surname);
            inputData = JSON.stringify(inputData);
            this.props.dispatch(TitoCashoutAcceptBet({barcode: data.barcode.toString(), amount: data.cashout_amount, inputData}));
            this.props.closePopup()();
        };
    }

    copyToBetSlip (game, market, event) {
        const command = (selections, games) => ({
            source: "betting",
            what: {
                sport: ['id', 'alias'],
                region: ['id'],
                competition: ['id'],
                game: [],
                market: [],
                event: ["id", "order", "name", "price", "type", "base"]
            },
            where: { game: { id: { "@in": games } }, event: { id: { "@in": selections } } }
        });
        return async () => {
            const { events: { event = [] } } = this.props.data.data;
            const eventIds = event.map(item => item.selection_id);
            const matchIds = event.map(item => item.match_id);
            const fullselectionsTree = (await Zergling.get(command(eventIds, matchIds))).data;
            Object.keys(fullselectionsTree.sport).filter(item => Object.prototype.hasOwnProperty.call(fullselectionsTree.sport, item)).map(item => {
                const sport = fullselectionsTree.sport[item];
                Object.keys(sport.region).filter(item => Object.prototype.hasOwnProperty.call(sport.region, item)).map(item => {
                    const region = sport.region[item];
                    Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.region, item)).map(item => {
                        const competition = region.competition[item];
                        Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).map(item => {
                            const game = competition.game[item];
                            Object.keys(game.market).filter(item => Object.prototype.hasOwnProperty.call(game.market, item)).map(item => {
                                const market = game.market[item];
                                //this.props.betslipEventsCount.some(eventCount => eventCount === market ? console.log(eventCount, "DONE!!!!!!!!!") : "noooooooo");
                                Object.keys(market.event).filter(item => Object.prototype.hasOwnProperty.call(market.event, item)).map(item => {
                                    const event = market.event[item];
                                    this.props.dispatch(addEventCompareConflicts({
                                        ...game,
                                        alias: sport.alias,
                                        regionId: region.id,
                                        competitionId: competition.id
                                    }, market, event, event.id));

                                    this.props.closePopup()();
                                });
                            });
                        });
                    });
                });
            });

        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_) => {
    let tid = JSON.parse(sessionStorage.getItem('authData')).tid;
    return createSelector(
        [
            state => state.swarmData.data.terminal_balance && state.swarmData.data.terminal_balance.terminals[tid] && state.swarmData.data.terminal_balance.terminals[tid].balance,
            state => state.betslip.events && Object.keys(state.betslip.events),
            state => state.terminal.isAdminLoggedIn

        ],
        (terminalBalance, betslipEvents, isAdminLoggedIn) => {
            return {
                terminalBalance,
                betslipEvents,
                isAdminLoggedIn
            };
        }
    );
};

TicketInDms.propTypes = {
    data: PropTypes.object,
    closePopup: PropTypes.func,
    openPopup: PropTypes.func,
    terminalBalance: PropTypes.number,
    tickets: PropTypes.array
};

export default connect(mapStateToProps)(UIMixin({Component: TicketInDms}));